﻿import {Core} from "../Base/Core";
import {UIText} from "./Tools/Base/UIText";
import {UISprite} from "./Tools/Base/UISprite";
import {UIButton} from "./Tools/Base/UIButton";
import {UILabeledIcon} from "./Tools/Base/UILabeledIcon";
import {Time} from "../Utils/Unity/Time";

export class FirstCreatureOfferButton extends UIButton {

    get IsActive() {
        return this.Active;
    }

    Awake() {
        super.Awake();

        this.back = this.addChild(new UISprite("offers/vip-badge-bg"));
        this.creatureContainer = this.addChild(new UISprite());
        this.creatureImg = this.creatureContainer.addChild(new UISprite());
        this.creatureContainer.mask = this.creatureContainer.addChild(new PIXI.Graphics)
            .beginFill(0xFFFFFF, 1).drawRect(0, 0, 1, 1)
        ;

        this.bonusField = this.addChild(new UIText("X6"));
        this.timerField  = this.addChild(new UILabeledIcon({
            label: "",
            backgroundAlpha: 0.75,
            textProps: {
                fitTextTemplate: "00m 00s",
            }
        }));
        this.lastUpdateTime = 0;

        this.onPlayerChanged = this.onPlayerChanged.bind(this);

        this.SetActive(false);

        this.tryToInitialize();
        Core.Player.on("Changed", this.onPlayerChanged);

        this.on("pointertap",  () => {
            Core.UI.firstCreatureOffer.Show();
        });
        this._initTapHighlight(this.back);
    }

    onPlayerChanged() {
        this.tryToInitialize();
    }

    tryToInitialize() {

        if (!Core.Store.IsInitialized) return;
        if (!Core.Time.Initialized) return;

        let active = !!Core.UI.firstCreatureOffer.offerTimeLeft;
        active &= Core.Player.PlanetsSave.currentPlanetId === Core.UI.firstCreatureOffer.planetId;

        this.SetActive(active);
        if (this.Active) this.Init();
    }

    Init() {
        if (!Core.Store.IsInitialized) return;
        if (!Core.Time.Initialized) return;

        if (!Core.UI.firstCreatureOffer.offerTimeLeft) {
            this.SetActive(false);
            return;
        }

        if (Core.UI.firstCreatureOffer.RequestedCreatureId) {
            this.creatureImg.setImage(`creatures/${Core.UI.firstCreatureOffer.RequestedCreatureId}`);
        }
        this.updateTime();
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);
        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.fitRect(rect);
        this.bonusField.fitLayout(rect.clone().pad(-rect.width * 0.3));

        let creatureRect = rect.clone().pad(rect.width * 0.1, rect.height * 0.1);
        this.creatureContainer.position.copyFrom(creatureRect);

        this.creatureContainer.mask.width = creatureRect.width;
        this.creatureContainer.mask.height = rect.height;

        creatureRect.x = creatureRect.y = 0;
        this.creatureImg.anchor.set(0.5, 0);
        this.creatureImg.fitRect(creatureRect);
        this.creatureImg.y = 0;

        let timerRect = rect.clone().pad(rect.width * 0.05, -rect.height * 0.35);
        timerRect.y = rect.height - timerRect.height;
        this.timerField.fitLayout(timerRect);
    }

    Update() {
        this.lastUpdateTime += Time.deltaTime;
        if (this.lastUpdateTime > 1) {
            if (Core.UI.firstCreatureOffer.RequestedCreatureId) {
                this.creatureImg.setImage(`creatures/${Core.UI.firstCreatureOffer.RequestedCreatureId}`);
            }
            this.updateTime();
            this.lastUpdateTime = 0;
            this.SetActive(
                (Core.UI.firstCreatureOffer.offerTimeLeft > 0)
                && Core.Player.PlanetsSave.currentPlanetId === Core.UI.firstCreatureOffer.planetId
            );
        }
    }

    updateTime() {
        let timeLeft = Core.UI.firstCreatureOffer.offerTimeLeft;
        this.timerField.label = NUtils.FormatSecondsToTime(timeLeft / 1000);
        if (timeLeft <= 0) {
            this.SetActive(false);
        }
    }
}

